import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { AssetSettings } from '@/components/Settings/AssetSettings';
import { SettingsHeader } from '@/components/Settings/SettingsHeader';
import { useCodebase } from '@/contexts/CodebaseContext';
import { searchParam } from '@/utils/router';

const treeSearchSchema = z.object({
  branchId: searchParam().optional(),
  versionId: searchParam().optional(),
});

export const Route = createFileRoute('/$organizationName/cb/$codebaseId/settings/general')({
  component: CodebaseSettingsGeneralPage,
  validateSearch: zodValidator(treeSearchSchema),
});

function CodebaseSettingsGeneralPage() {
  const { codebaseId, organizationName } = Route.useParams();
  const { codebase } = useCodebase();

  const isAssetAdmin = codebase?.effective_role === 'asset_admin';

  return (
    <>
      <SettingsHeader newHeader title="Codebase Settings" className="mb-10" />

      <AssetSettings
        showManagePermissionsButton
        assetId={codebaseId}
        assetName="Codebase"
        isAssetAdmin={isAssetAdmin}
        deleteMessage="Once you remove this codebase from Driver, there is no going back. You will need to reconnect and regenerate all documentation. Please be certain."
        backTo="/$organizationName/library"
        backParams={{ organizationName: organizationName }}
      />
    </>
  );
}
